export const background = '#1C1B1B'
export const mainText = '#FFD9D9'
export const helperText = '#FFD9D9'
export const focusText = '#FF5B5B'